import React, { useState } from 'react';
import Navbar from './Navbar';
import ContentItem from './ContentItem';
import dummyData from '../dummyData';
import './HomePage.css';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function HomePage() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const featuredColdKnowledge = dummyData['cold-knowledge'] ? dummyData['cold-knowledge'].slice(0, 1) : [];
  const featuredStrangeQuestion = dummyData['strange-questions'] ? dummyData['strange-questions'].slice(0, 1) : [];

  const popularTags = ['科学', '动物', '历史', '脑洞', '心理学', '太空'];

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?query=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const siteUrl = process.env.PUBLIC_URL || "http://localhost:3000";
  const pageTitle = "无聊百科 - 首页 | 有点意思但不多";
  const pageDescription = "欢迎来到无聊百科！发现最新鲜的冷知识、最奇怪的问题和最有趣的脑洞。每天都有新发现，让你的好奇心得到满足。";
  const canonicalUrl = `${siteUrl}/`;

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={canonicalUrl} />
        {/* Open Graph / Facebook for this page */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content={`${siteUrl}/logo512.png`} /> 
        {/* Twitter Card for this page */}
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:url" content={canonicalUrl} />
        <meta name="twitter:image" content={`${siteUrl}/logo512.png`} />
      </Helmet>
      <div className="homepage">
        <Navbar />

        <header className="hero-section">
          <h1>无聊百科</h1>
          <p className="subtitle">有点意思，但不多</p>
          {featuredColdKnowledge.length > 0 && (
            <div className="daily-feature">
              <h3>今日冷知识推荐</h3>
              <ContentItem item={{...featuredColdKnowledge[0], category: 'cold-knowledge'}} />
            </div>
          )}
        </header>

        <section className="search-section">
          <form onSubmit={handleSearchSubmit}>
            <input 
              type="search" 
              placeholder="搜点啥好呢..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
            <button type="submit">搜索</button>
          </form>
        </section>

        <main className="main-content">
          <section className="content-showcase">
            <h2><Link to="/categories/strange-questions">怪问题精选</Link></h2>
            <div className="items-grid">
              {featuredStrangeQuestion.length > 0 ? (
                <ContentItem item={{...featuredStrangeQuestion[0], category: 'strange-questions'}} />
              ) : (
                <p>暂时没有精选怪问题。</p>
              )}
              {/* Add more items or a link to the category page */} 
            </div>
          </section>

          <section className="tags-section">
            <h2>热门标签</h2>
            <div className="tags-cloud">
              {popularTags.map(tag => (
                <Link key={tag} to={`/tags/${encodeURIComponent(tag)}`} className="tag">
                  {tag}
                </Link>
              ))}
            </div>
          </section>
        </main>

        <footer className="footer">
          <p>&copy; {new Date().getFullYear()} 无聊百科. All rights reserved (not really).</p>
          {/* <p><Link to="/categories">所有分类</Link></p> Removed as per request */}
        </footer>
      </div>
    </>
  );
}

export default HomePage;
